import { Injectable } from '@angular/core';
import { DevEntityService, ReleaseStore } from '@frontend-site/shared/core';
import { AsEntityTypeNames } from '@frontend-site/shared/data';
import { map, Observable } from 'rxjs';
import { DefaultMainHeaderMenu, MainHeaderMenu, MenuItem, MenuStates, RouteData } from '../../models';
import { MENU_IDS } from '../menu-ids';
import { MenuBuilderService } from './menu-builder';

@Injectable()
export class InReleaseMenuBuilderService implements MenuBuilderService {
    get menuState(): MenuStates {
        return MenuStates.RELEASE;
    }

    constructor(private readonly releaseStore: ReleaseStore, private readonly devEntityService: DevEntityService) {}

    build$(routeData: RouteData): Observable<MainHeaderMenu | null> {
        const { id, companyId } = routeData.params || {};

        return this.releaseStore.currentReleaseName$.pipe(map((releaseName) => this.create(id, companyId, releaseName ?? '')));
    }

    private create(id: number, companyId: number, releaseName: string): MainHeaderMenu {
        const menu = new DefaultMainHeaderMenu(this.menuState, { title: releaseName })
            .addMenuItem(this.createOverviewMenu(id, companyId))
            .addMenuItem(this.createRequirementsMenu(id, companyId))
            .addMenuItem(this.createReportsMenu(id, companyId));

        return menu;
    }

    private createOverviewMenu(id: number, companyId: number): MenuItem {
        return {
            id: MENU_IDS.RELEASE.OVERVIEW.DEFAULT,
            label: 'Enumerations.ApplicationModules.OVERVIEW_MENU.OVERVIEW',
            routePath: `/releaseDynamix/${companyId}/release/${id}/risk`,
            menu: [
                {
                    id: MENU_IDS.RELEASE.OVERVIEW.RISK_COCKPIT,
                    label: 'Enumerations.ApplicationModules.OVERVIEW_MENU.RISK_COCKPIT',
                    routePath: `/releaseDynamix/${companyId}/release/${id}/risk`
                },
                {
                    id: MENU_IDS.RELEASE.OVERVIEW.RELEASE_OVERVIEW,
                    label: 'Enumerations.ApplicationModules.OVERVIEW_MENU.RELEASE_OVERVIEW',
                    routePath: `/releaseDynamix/${companyId}/release/${id}/progress`
                },
                {
                    id: MENU_IDS.RELEASE.OVERVIEW.RELEASE_DETAILS,
                    label: 'Enumerations.ApplicationModules.OVERVIEW_MENU.RELEASE_DETAILS',
                    routePath: `/releaseDynamix/${companyId}/release/${id}/general`,
                    settings: { showDivider: true }
                }
            ]
        };
    }

    private createRequirementsMenu(id: number, companyId: number): MenuItem {
        const label = this.devEntityService.getDevEntityTranslateKey(AsEntityTypeNames.REQUIREMENT.toLowerCase(), true);
        return {
            id: MENU_IDS.RELEASE.REQUIREMENTS,
            label: label,
            routePath: `/releaseDynamix/${companyId}/release/${id}/requirements`
        };
    }
    private createReportsMenu(id: number, companyId: number): MenuItem {
        return {
            id: MENU_IDS.RELEASE.REPORTS,
            label: 'Enumerations.ApplicationModules.REPORTS',
            routePath: `/reports/${companyId}/releaseReports/${id}`
        };
    }
}
